import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource/playfair-display/latin-700-italic.css'
import '@fontsource/cinzel/latin-700.css'
import 'remixicon/fonts/remixicon.css'
import './index.css'
import App from './App.tsx'
import { preloadRoute } from './router/config'

// BrowserRouter lives here (not in App) so entry-server.tsx can wrap the same <App /> in StaticRouter.
const container = document.getElementById('root')!
const app = (
  <StrictMode>
    <BrowserRouter basename={__BASE_PATH__}>
      <App />
    </BrowserRouter>
  </StrictMode>
)

if (container.hasChildNodes()) {
  // Prerendered page: load the route's lazy chunk first so hydration adopts the server HTML
  // (see _seo-kit/pattern/PATTERN.md, "Preload the route chunk before hydrating").
  // A failed preload is not fatal here: the lazy route retries and reports it as before.
  preloadRoute(window.location.pathname)
    .catch(() => undefined)
    .then(() => hydrateRoot(container, app))
} else {
  // Dev server (empty #root): nothing to hydrate.
  createRoot(container).render(app)
}
